import { Box, Card, Grid, Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { useState } from "react";
import { FadeInt2Div } from "styledComponents/animation";

import CurrentOfflineList from "./currentOfflineOrders";
import InsertOrders from "./insertOrders";
import OfflineOrdersActiveOrderTable from "./activeOrderTable";
import OfflineOrdersHistory from "./historyTable";
const OfflineOrders = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        className={`${classes.header} py-0 rounded-lg`}
      >
        <Tabs
          scrollButtons="auto"
          textColor="primary"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className={classes.tabsContainer}
        >
          <Tab label="ایجاد سفارش" {...a11yProps(0)} className={classes.Tab} />
          <Tab
            label="تاریخچه سفارشات"
            {...a11yProps(1)}
            className={classes.Tab}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} className={classes.TabPanel}>
        <FadeInt2Div>
          <Card sx={{ padding: { sm: 2 }, borderRadius: "4px" }}>
            <Grid container spacing={6} sx={{ padding: 2, minHeight: 500 }}>
              <Grid item xs={12} md={4}>
                <InsertOrders />
              </Grid>
              <Grid item xs={12} md={8}>
                <CurrentOfflineList />
              </Grid>
            </Grid>
          </Card>
          {/* <Card sx={{ padding: 2, borderRadius: "4px", marginBlockStart: 2 }}> */}
          {/* <OfflineOrdersActiveOrderTable /> */}
          {/* </Card> */}
        </FadeInt2Div>
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.TabPanel}>
        <FadeInt2Div>
          <OfflineOrdersHistory />
        </FadeInt2Div>
      </TabPanel>
    </Box>
  );
};

export default OfflineOrders;

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
  },
  TabPanel: {
    "& > div": {
      padding: { xs: 0, md: "20px !important" },
    },
    "& > div > div": {
      width: "100%",
    },
  },
  Tab: {
    fontWeight: "bold !important",
    fontSize: "1rem",
    color: "#333",
    "&.Mui-selected": {
      color: "#1976d2",
    },
    "&:hover": {
      color: "#1976d2",
      backgroundColor: "#f0f4ff",
      borderRadius: "4px",
    },
  },
  tabsContainer: {
    borderBottom: "1px solid #ddd",
    padding: "0 24px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));
